export interface InternalToastContent {
  message: string;
  tone: 'info' | 'success' | 'warning' | 'critical';
}

export interface UNSTABLE_ToastOptions {
  /**
   * The timeout to automatically close the toast after, in milliseconds.
   * Setting this to `0` will prevent the toast from automatically closing.
   * The minimum timeout is 5000 milliseconds.
   * @default 5000
   */
  timeout?: number;
}
